<template>
  <v-card elevation="0" rounded="0" color="borderInner" class="gradientBackground" @contextmenu.prevent="null" style="user-select: none; cursor: default;">
    <v-card color="primary" :width="$vuetify.display.mobile ? '90vw' : '50vw'" style="padding: 20px; position: relative; z-index: 1;">
      <img :src="require('../assets/images/logo.webp')" draggable="false" style="width: 250px; height: auto; display: block; margin: 0 auto;"/>
      <br>
      <v-text-field 
        v-model="input.CRMAgentUsername"
        @keydown.enter.prevent="login(input.CRMAgentUsername, input.CRMAgentPassword)" 
        :loading="loader.login"
        :disabled="loader.login"
        placeholder="Nombre de usuario" 
        variant="solo-filled" 
        density="compact"
        autocomplete="off"
      ></v-text-field>
      <v-text-field 
        v-model="input.CRMAgentPassword" 
        @keydown.enter.prevent="login(input.CRMAgentUsername, input.CRMAgentPassword)" 
        :loading="loader.login"
        :disabled="loader.login"
        @click:append-inner="input.CRMAgentPasswordIsHidden = !input.CRMAgentPasswordIsHidden;" 
        :append-inner-icon="input.CRMAgentPasswordIsHidden ? 'mdi-eye' : 'mdi-eye-off'" 
        :type="input.CRMAgentPasswordIsHidden ? 'password' : 'default'" 
        placeholder="Contraseña" 
        variant="solo-filled" 
        density="compact"
        autocomplete="off"
      ></v-text-field>
      <br>
      <v-btn @click="login(input.CRMAgentUsername, input.CRMAgentPassword)" :disabled="loader.login" block color="indigo" class="hoverableText">
        <v-icon style="margin-right: 10px;">mdi-login</v-icon>
        <h3>INICIAR SESIÓN</h3>
      </v-btn>
    </v-card>
  </v-card>
</template>

<style scoped>
  .gradientBackground {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: radial-gradient(circle at 70% 80%, rgba(63,81,181,0.4), transparent 50%),
                radial-gradient(circle at 20% 30%, rgba(33,150,243,0.3), transparent 50%),
                radial-gradient(circle at 50% 50%, rgba(156,39,176,0.2), transparent 50%);
    background-size: 200% 200%;
    animation: gradientFlow 10s ease-in-out infinite alternate;
  }

  @keyframes gradientFlow {
    0% {
      background-position: 60% 80%, 20% 30%, 50% 50%;
    }
    25% {
      background-position: 40% 60%, 30% 40%, 60% 40%;
    }
    50% {
      background-position: 30% 20%, 50% 60%, 40% 70%;
    }
    75% {
      background-position: 50% 80%, 20% 50%, 60% 30%;
    }
    100% {
      background-position: 60% 80%, 20% 30%, 50% 50%;
    }
  }
</style>

<script>
  export default {
    inject: ['$generalFunctions', '$localStorageFunctions'],
    data: () => 
    ({
      input: 
      {
        CRMAgentUsername: null,
        CRMAgentPassword: null,
        CRMAgentPasswordIsHidden: true
      },
      loader: 
      {
        login: false
      }
    }),
    methods:
    {
      async login(CRMAgentUsername, CRMAgentPassword){
        this.loader.login = true;
        const loginRequestQuery =
        {
          'CRMAgentUsername': CRMAgentUsername,
          'CRMAgentPassword': CRMAgentPassword
        };
        const loginResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/login', loginRequestQuery);
        if (loginResult.success){
          if (loginResult.result){
            localStorage.setItem('CRMAccountID', loginResult.result.CRMAccountID);
            localStorage.setItem('CRMAgentID', loginResult.result.CRMAgentID);
            localStorage.setItem('CRMAgent_u', CRMAgentUsername);
            localStorage.setItem('CRMAgent_p', CRMAgentPassword);

            this.$generalFunctions.default.navigateTo(loginResult.result.CRMAgentLandingPage);
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('LoginView_login_error', 'error', 'No existe un usuario activo que coincida con el nombre de usuario y contraseña', null, true);
          }
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('LoginView_login_error', 'error', 'Ha ocurrido un error inesperado al iniciar sesión, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.login = false;
      }
    },
    mounted(){
      const CRMUserCredentials = this.$localStorageFunctions.default.getCRMUserCredentials();
      if (CRMUserCredentials.CRMAccountID != null && CRMUserCredentials.CRMAgentID != null){
        this.$generalFunctions.default.navigateTo('/chat');
      }

      if (localStorage.getItem('CRMAgent_u') != null && localStorage.getItem('CRMAgent_p') != null){
        if (confirm('¿Iniciar sesión con usuario previo?')){
          this.login(localStorage.getItem('CRMAgent_u'), localStorage.getItem('CRMAgent_p'));
        }
      }

    }
  }
</script>